import { UserRound, Wrench, Building2, Users, Briefcase, FolderKanban, Check } from "lucide-react";

const ACTIVITIES = [
  { key: "find_work", title: "Find Work", description: "Post a résumé and apply for jobs", Icon: UserRound },
  { key: "offer_service", title: "Offer a Service", description: "Advertise your personal or professional services", Icon: Wrench },
  { key: "promote_company", title: "Promote a Company", description: "Create a business page and list services", Icon: Building2 },
  { key: "hire", title: "Hire Someone", description: "Find jobseekers or companies", Icon: Users },
  { key: "post_job", title: "Post a Job", description: "Advertise full-time, part-time or contractual jobs", Icon: Briefcase },
  { key: "post_project", title: "Post a Project", description: "Request proposals, quotations or competitive bids", Icon: FolderKanban },
] as const;

// [account.activities](../../../docs/product/accounts.md#account-activities): signup and later activity setup share these choices; parents
// own saved capabilities, additive provisioning and the empty-selection default.
export function SignupActivityChoices({ picked, busy, onToggle }: { picked: string[]; busy: boolean; onToggle: (activity: string) => void }) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {ACTIVITIES.map(({ key, title, description, Icon }) => {
        const selected = picked.includes(key);
        return (
          <button id={`activity-choice-${key}`} key={key} type="button" aria-pressed={selected} disabled={busy} onClick={() => onToggle(key)}
            className={`flex min-h-16 items-center gap-2.5 rounded-xl border p-3 text-left transition xl:min-h-24 xl:items-start xl:p-3.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy disabled:opacity-60 ${selected ? "border-navy-500 bg-navy-50 ring-2 ring-navy-50" : "border-line bg-white/90 hover:border-navy-500"}`}>
            <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg ${selected ? "bg-navy text-white" : "bg-navy-50 text-navy"}`}>
              {selected ? <Check className="h-5 w-5" aria-hidden="true" /> : <Icon className="h-5 w-5" aria-hidden="true" />}
            </span>
            <span className="min-w-0"><span className="block text-base font-semibold leading-5 text-navy xl:text-sm">{title}</span><span className="mt-1 hidden text-xs leading-5 text-mut xl:block">{description}</span></span>
          </button>
        );
      })}
    </div>
  );
}
